import React from 'react';
import { Typography, Box } from '@lucid/lego';
import { useStore } from '../../store/store';

const Notifications: React.FC = () => {
  const theme = useStore((state) => state.theme);

  return (
    <Box>
      <Typography variant="headline" size="small" color="primary-1" theme={theme}>
        Notifications
      </Typography>
      <Box mt={24}>
        <Typography variant="body" size="medium" color="primary-1" theme={theme}>
          Your notifications will appear here.
        </Typography>
      </Box>
    </Box>
  );
};

export default Notifications;
